import { type TemplateOnlyComponent } from '@ember/component/template-only';

interface DividerSignature {
  Element: HTMLDivElement;
  Args: {
    vertical?: boolean;
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    Divider: typeof Divider;
  }
}

const Divider: TemplateOnlyComponent<DividerSignature> = <template>
  <div class='relative z-10' ...attributes>
    <sl-divider
      {{! template-lint-disable no-inline-styles }}
      class='absolute border-divider
        {{if @vertical "border-l" "w-full border-t"}}'
      vertical={{@vertical}}
      style='--spacing: 0'
    ></sl-divider>
  </div>
</template>;

export default Divider;
